import React, {Component} from 'react';

import _ from "lodash";

import formatters from "../../../../utils/formatters";


export default class TripMetadata extends Component {

    render() {
        let {trip} = this.props;
        if(!trip)return <div />;

        let {product} = trip;
        let dispatchLabel = '';
        let dischargeLabel = '';
        if(product){
            if(product.origin_unit_of_measure){
                dispatchLabel = _.capitalize(product.origin_unit_of_measure);
                if(product.origin_density){
                    dispatchLabel = `${dischargeLabel} a ${formatters.floatFormat(product.origin_density)}º`;
                }
            }
            if(product.terminal_unit_of_measure){
                dischargeLabel = _.capitalize(product.terminal_unit_of_measure);
                if(product.terminal_density){
                    dischargeLabel = `${dischargeLabel} a ${formatters.floatFormat(product.terminal_density)}º`;
                }
            }
        }

        return (
            <div className={"trip-metadata trip-fixed-information"}>
                <div className={"row no-margin"}>
                    <div className={"col s1"}>
                        <label className="active">Remito</label>
                        <p className={"field-p-no-border"}>
                            {trip.provider_trip_receipt}
                        </p>
                    </div>
                    <div className={"col s2"}>
                        <label className="active">Proveedor</label>
                        <p className={"field-p-no-border truncate"}>
                            {trip.provider.business_name}
                        </p>
                    </div>
                    <div className={"col s2"}>
                        <label className="active">Chofer</label>
                        <p className={"field-p-no-border"}>
                            {trip.driver_name}
                        </p>
                    </div>
                    <div className={"col s1"}>
                        <label className="active">Patente Chasis</label>
                        <p className={"field-p-no-border"}>
                            {trip.truck_plate}
                        </p>
                    </div>
                    <div className={"col s2"}>
                        <label className="active">Producto</label>
                        <p className={"field-p-no-border"}>
                            {trip.product.code}
                        </p>
                    </div>
                    <div className={"col s2"}>
                        <label className="active">Cargado</label>
                        <p className={"field-p-no-border"}>
                            {formatters.intFormat(trip.provider_load_volume)} {dispatchLabel}
                        </p>
                    </div>
                    <div className={"col s2"}>
                        <label className="active">Descargado</label>
                        <p className={"field-p-no-border"}>
                            {formatters.intFormat(trip.unload_volume)} {dischargeLabel}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/TripMetadata.js